<template>
  <v-container :class="['container', { 'with-margin': showingSidebar && !temporarySidebar }]">
    <v-slide-x-transition mode="out-in">
      <v-value-mapper v-if="feature" />
      <!-- show some info messages while there is no content to show -->
      <v-messages v-else />
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import VMessages from "./Messages";
import VValueMapper from "./value-mapper/Layout";

export default {
  components: {
    VMessages,
    VValueMapper
  },
  computed: {
    ...mapState("valueMapping", [
      "feature",
      "showingSidebar",
      "temporarySidebar"
    ])
  }
};
</script>

<style scoped>
.container {
  margin-left: 0;
  transition: all 0.5s;
}

.with-margin {
  transition: all 0.5s;
  margin-left: 300px;
}
</style>
